/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */

export type TransactionTypes = typeof TransactionTypes[keyof typeof TransactionTypes];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransactionTypes = {
  C2B: 'C2B',
  B2C: 'B2C',
} as const;
